import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "../constants"; 
const TECHNICIAN_SHARE = 0.85;

export default function TechnicianPayment() {
  const [orders, setOrders] = useState([]);
  const [paymentInputs, setPaymentInputs] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
  try {
    const res = await fetch(AIRTABLE_URL, {
      headers: AIRTABLE_HEADERS, // ✅ centralized headers
    });

        const json = await res.json();

        const records = json.records.map((rec) => ({
          id: rec.id,
          ...rec.fields,
        }));

        const filtered = records.filter(
          (item) =>
            item?.assignedTechnicianPhone &&
            item?.paid?.toString().toLowerCase() === "true" &&
            item?.workCompleted?.toString().toLowerCase() === "true" &&
            parseInt(item.technicianEarning || 0) === 0
        );

        const processed = filtered.map((item) => {
          const service = parsePrice(item.total || item.services);
          const extra = parseExtraPartsTotal(item.extraParts);
          const grand = service + extra;
          const earning = Math.round(grand * TECHNICIAN_SHARE);

          return {
            ...item,
            service,
            extra,
            grand,
            earning,
            date: item.timestamp?.split(",")[0] || "N/A",
          };
        });

        setOrders(processed);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchData();
  }, []);

  const parsePrice = (str) => {
    if (!str) return 0;
    const matches = [...str.matchAll(/₹\s?(\d+)/g)];
    return matches.reduce((sum, match) => sum + parseInt(match[1]), 0);
  };

  const parseExtraPartsTotal = (extraStr) => {
    if (!extraStr || extraStr === "None") return 0;
    return extraStr.split(",").reduce((sum, part) => {
      const match = part.match(/₹\s?(\d+)/);
      return sum + (match ? parseInt(match[1]) : 0);
    }, 0);
  };

  const handlePaymentChange = (id, value) => {
    setPaymentInputs({ ...paymentInputs, [id]: value });
  };

  const handleSubmit = async (id) => {
    const amount = parseInt(paymentInputs[id]);
    if (!amount || isNaN(amount)) {
      alert("❌ Enter a valid amount");
      return;
    }

    try {
     await fetch(`${AIRTABLE_URL}/${id}`, {
  method: "PATCH",
  headers: AIRTABLE_HEADERS, // ✅ centralized headers
  body: JSON.stringify({
    fields: {
      technicianEarning: String(amount),
    },
  }),
});

      setOrders((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      console.error("Payment update failed:", err);
      alert("❌ Failed to update Airtable.");
    }
  };

  return (
    <div style={{ padding: "40px 0", position: "relative" }}>
      <button
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          background: "none",
          border: "none",
          fontSize: 20,
          cursor: "pointer",
        }}
      >
        ✖
      </button>

      <h2>💳 Pay Technicians</h2>

      {orders.length === 0 ? (
        <p>✅ All payments completed.</p>
      ) : (
        orders.map((item) => (
          <div key={item.id} style={styles.card}>
            <div style={styles.row}><strong>Technician:</strong> {item.assignedTechnicianPhone}</div>
            <div style={styles.row}><strong>Order ID:</strong> {item.orderId}</div>
            <div style={styles.row}><strong>Services:</strong> {item.services}</div>
            <div style={styles.row}><strong>Service Total:</strong> ₹{item.service}</div>
            <div style={styles.row}><strong>Extra Parts:</strong> {item.extraParts || "None"}</div>
            <div style={styles.row}><strong>Extra Parts Total:</strong> ₹{item.extra}</div>
            <div style={styles.row}><strong>Grand Total:</strong> ₹{item.grand}</div>
            <div style={styles.row}><strong>Technician Earning (85%):</strong> ₹{item.earning}</div>
            <div style={styles.row}><strong>Date:</strong> {item.date}</div>
            <div style={styles.row}>
              <strong>Enter Amount:</strong>{" "}
              <input
                type="number"
                placeholder={`₹${item.earning}`}
                value={paymentInputs[item.id] || ""}
                onChange={(e) => handlePaymentChange(item.id, e.target.value)}
              />
            </div>
            <button
              onClick={() => handleSubmit(item.id)}
              style={styles.payButton}
            >
              ✅ Submit Payment
            </button>
          </div>
        ))
      )}
    </div>
  );
}

const styles = {
  card: {
    border: "1px solid #ccc",
    borderRadius: 8,
    padding: 15,
    marginBottom: 15,
    background: "#fff",
  },
  row: {
    marginBottom: 6,
  },
  payButton: {
    marginTop: 10,
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: 4,
    cursor: "pointer",
  },
};
